import { jsx as _jsx } from "react/jsx-runtime";
import { useBoxOnRSS3 } from '@/contexts/RSS3Provider';
import { useBoxInfo } from '@/hooks';
import { Maskbox } from './index';
export const WrapMaskbox = (props) => {
    const { boxOnSubgraph: box } = props;
    const boxId = box?.box_id.toString();
    const { box: boxOnChain } = useBoxInfo(boxId);
    const boxOnRSS3 = useBoxOnRSS3(box?.creator, boxId);
    return _jsx(Maskbox, { ...props, boxOnChain: boxOnChain, boxOnRSS3: boxOnRSS3 });
};
